module.exports = __webpack_public_path__ + "img/rafael.4093d639.jpg";